'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var Dom = require('react-dom');
var AutoSizeHelper = require('../common/AutoSizeHelper');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');

/**
 * 菜单栏组件
 */
var MenuBarItem = React.createClass({
  propTypes: {
    onClickEvent: React.PropTypes.func.isRequired,
    selected: React.PropTypes.bool.isRequired
  },

  render: function () {
    var backgroundStyle = {
      backgroundColor: this.props.selected ? this.props.selectedColor : undefined
    };
    return (<div style={backgroundStyle} className="item-bg" onClick={this.props.onClickEvent}>
        <label>{util.Text.convertSpaceToNbsp(this.props.text)}</label>
    </div>);
  }
});

var MenuBar = React.createClass({

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
  },

  getInitialState: function () {
    return {
      selectedIndex: parseInt(this.props.selectedIndex, 10)
    };
  },

  render: function () {
    this.textArray = util.Text.delimitToWords(styleHelper.getText(this.props));
    var borderStyle = {
      lineHeight: styleHelper.getHeight(this.props) + 'px',
      // display: 'flex'
    };
    styleHelper.StyleUtil(this.props, borderStyle).base().background().border().text();
    return (
      <div style={borderStyle}>
        <div style={{width: 10000}}>
          {
            this.textArray.map(function (text, index) {
              return (<MenuBarItem {...this.props}
                                   key={index}
                                   text={text}
                                   selected={this.state.selectedIndex == index}
                                   onClickEvent={this.onItemClick.bind(this, null, index)}
              />);
            }, this)
          }
        </div>
    </div>);
  },

  onItemClick: function (e, index) {
    this.setState({selectedIndex: index});
  }

});

module.exports = MenuBar;




// WEBPACK FOOTER //
// ./src/views/Components/MenuBar.jsx